import { render } from "./roleIndex.vue?vue&type=template&id=2dd95276"
import script from "./roleIndex.vue?vue&type=script&lang=js"
export * from "./roleIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/saas-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__